import SeptemberOffer from "pages/SeptemberOffer";

export default function SeptemberOfferPage() {
  return <SeptemberOffer />;
}
